export default __webpack_public_path__ + "assets/images/5e98df32422b22180d693a870e13b842.png";